module.exports = __webpack_public_path__ + "img/DAB-Profile-Subir.b5740f16.png";